import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import DialogTransition from "@icarius-common/dialogTransition";
import { massiveWorkingDayAction } from "@icarius-pages/myPeople/actions";
import { getEditableFields } from "../../selectors";
import Loader from "@icarius-common/loader";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';

const gridStyle = { margin: 10 };

const WorkingDayDialog = (props) => {

  const {
    open,
    isLoading,
    employees,
    handleAfterSubmit,
    handleClose
  } = props;

  const [type, setType] = useState('');
  const [hoursDay, setHoursDay] = useState('');
  const [hoursWeek, setHoursWeek] = useState('');
  const [hoursMonth, setHoursMonth] = useState('');

  const editableFields = useSelector(getEditableFields);
  const typesArray = editableFields
    .find(item => item.name === 'TIPO DE JORNADA').options
    .map(item => ({ key: item.id, value: item.value }))
    .filter(item => item.key !== '-');

  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (type && hoursDay && hoursMonth) {
      if (hoursDay >= 0 && hoursMonth >= 0) {
        dispatch(massiveWorkingDayAction({
          codes: employees.map(item => item.code),
          type,
          hoursDay,
          hoursWeek,
          hoursMonth,
        }))
          .then((resp) => {
            if (resp.status === 200) {
              handleAfterSubmit(resp?.data?.showAlert);
            }
            handleClose();
          });
      } else {
        dispatch(openSnackbarAction({ msg: getLocalizedString("numericFieldsMustHavePositiveValues"), severity: "warning" }));
        return;
      }
    } else {
      dispatch(openSnackbarAction({ msg: getLocalizedString("digitalFolderValidation"), severity: "warning" }));
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("workdayChange")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-type`}>{getLocalizedString("jornadaType")}</InputLabel>
                <Select
                  value={type}
                  labelId={`label-type`}
                  id={`select-type`}
                  onChange={(e) => setType(e.target.value)}
                  margin={"none"}
                >
                  {
                    typesArray.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextField
                required
                label={getLocalizedString("hoursPerDay")}
                fullWidth
                value={hoursDay}
                InputProps={{ inputComponent: CustomNumberFormat }}
                inputProps={{ min: 1, max: 24, step: 0.05, decimals: 2, isAllowed: (v) => v.floatValue === undefined || v.floatValue <= 24 }}
                margin={"none"}
                onChange={e => {
                  setHoursDay(e.target.value);
                }}
                helperText={getLocalizedString("mustBePositiveNumber")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextField
                required
                label={getLocalizedString("weeklyHoursContract")}
                fullWidth
                value={hoursWeek}
                InputProps={{ inputComponent: CustomNumberFormat }}
                inputProps={{ min: 1, step: 0.05, decimals: 2 }}
                margin={"none"}
                onChange={e => {
                  setHoursWeek(e.target.value);
                }}
                helperText={getLocalizedString("mustBePositiveNumber")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextField
                required
                label={getLocalizedString("hoursPerMonth")}
                fullWidth
                value={hoursMonth}
                InputProps={{ inputComponent: CustomNumberFormat }}
                inputProps={{ min: 1, step: 0.05, decimals: 2 }}
                margin={"none"}
                onChange={e => {
                  setHoursMonth(e.target.value);
                }}
                helperText={getLocalizedString("mustBePositiveNumber")}
              />
            </Grid>
          </Grid>
          <Typography className="whiteText" style={{ margin: 10, fontWeight: 500 }}>
            {getLocalizedString("workingDayQuestion", { length: employees.length })}
          </Typography>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
          <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default WorkingDayDialog;
